import { visitReportApi } from "@/core/apis";

// getter types
export const VISIT_REPORTS = "visitReports";

// action types
export const GET_VISIT_REPORTS = "getVisitReports";

// mutation types
const SET_VISIT_REPORTS = "setVisitReports";

const state = {
  visitReports: []
};

const getters = {
  [VISIT_REPORTS](state) {
    return state.visitReports;
  }
};

const actions = {
  [GET_VISIT_REPORTS](context) {
    return new Promise(resolve => {
      visitReportApi.getAllVisitForms().then(response => {
        context.commit(SET_VISIT_REPORTS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_VISIT_REPORTS](state, visitReports) {
    state.visitReports = visitReports;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
